import React from 'react';
import './App.css';
import Header from './components/Header';
import {Route} from 'react-router-dom';
// import Home from './components/Home'
import Portfolio from './components/Portfolio';
import Skills from './components/Skills';
import About from './components/About';
import Links from './components/Links';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Header/>
      {/* <Route exact path="/" component={Home}/> */}
      <Route exact path="/portfolio" component={Portfolio}/>
      <Route exact path="/skills" component={Skills}/>
      <Route exact path="/" component={About}/>
      <Route exact path="/about" component={About}/>
      <Route exact path="/links" component={Links}/>
      <Route exact path="/contact" component={Contact}/>
      <Footer/>
    </div>
  );
}

export default App;
